/*
 * @Copyright: Copyright (c) VizvaLab. All rights reserved.
 * @Author: Raguvind Tharanitharan
 * @Date: 2022-09-12 10:18:12
 * @Last Modified by: Raguvind Tharanitharan
 * @Last Modified time: 2022-09-12 22:12:00
*/
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import withRouter from '../../with-router';
import { loadSettingsFromService } from "../stores/legacy-settings";
import { PrayView } from '../../common';
import EventService from '../../common/services/events-service';
import '../styles/local-style.css';

export default withRouter(function LegacyAnalyticsView(props) {
  const [loaded, setloaded] = useState(false);
  const [setting, setsetting] = useState({});
  const { artist } = props.router.params;
  const dispatch = useDispatch();
  useEffect(() => {
    if (loaded === false) {
      dispatch(loadSettingsFromService(artist))
        .unwrap()
        .then(data => {
          // console.log(data);
          setloaded(true);
          setsetting({
            artistName: data.artistName,
            handle: data.handle,
            reportUrl: data.reportUrl,
          });
        })
        .catch(e => {
          EventService.logEvent('Error', { view_name: 'Legacy Analytics', error_description: e.message, url: window.location.href, artist_name: artist });
          console.log(e);
          // setloaded(false);
        });
    }
  });
  return <PrayView>
    <div className='legacy-root-container'>
      {!loaded && <div className='legacy-loader'></div>}
      {loaded && <iframe title='Pray-Analytics' className='legacy-analytic-report-container' src={setting.reportUrl} />}
    </div>
  </PrayView>;
});